import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import AffiliateOrderReport from 'Services/SalesManagement/Features/Report/Components/AffiliateOrderReport'
import TicketSaleReport from 'Services/SalesManagement/Features/Report/Components/TicketSaleReport'
import WebShopOrderReport from 'Services/SalesManagement/Features/Report/Components/WebShopOrderReport'
import { ReportType } from 'Services/SalesManagement/Features/Report/reportSlice'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import useHash from 'Util/hooks/useHash'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Tab } from '@mui/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

export default function ReportPage() {
  const navigate = useNavigate()
  const hash = useHash()

  const title = t`Reports`

  const [tabValue, setTabValue] = useState<ReportType>((hash as ReportType) || ReportType.WEBSHOP)

  const handleTabChange = (_event: React.SyntheticEvent, newValue: ReportType) => {
    navigate(`#${newValue}`)
    setTabValue(newValue)
  }

  const breadcrumbs = [
    {
      title: t`Home`,
      link: SALES_MANAGEMENT_ROOT_URL
    },
    {
      title: title
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 2 }}>
        <Breadcrumbs items={breadcrumbs} />
        <BackButton link={SALES_MANAGEMENT_ROOT_URL} />
        <PageTitle>{title}</PageTitle>
        <Typography component="p" variant="subtitle1" sx={{ fontSize: '15px', mb: 4 }}>
          {t`In the reports section, you can create sales reports for orders made in the Waltti webshop, Waltti Mobile, and Waltti points of sale, as well as for group ticket sales made in Waltti Manager.`}
        </Typography>
      </Box>
      <TabContext value={tabValue}>
        <Paper>
          <TabList onChange={handleTabChange} aria-label={t`Report tab list`}>
            <Tab label={t`Waltti webshop`} value={ReportType.WEBSHOP} />
            <Tab label={t`Mobile and points of sale`} value={ReportType.AFFILIATE} />
            <Tab label={t`Group tickets`} value={ReportType.GROUP_TICKET} />
          </TabList>
        </Paper>
        <TabPanel sx={{ px: 0, pt: 1 }} value={ReportType.WEBSHOP}>
          <WebShopOrderReport />
        </TabPanel>
        <TabPanel sx={{ px: 0, pt: 1 }} value={ReportType.AFFILIATE}>
          <AffiliateOrderReport />
        </TabPanel>
        <TabPanel sx={{ px: 0, pt: 1 }} value={ReportType.GROUP_TICKET}>
          <TicketSaleReport />
        </TabPanel>
      </TabContext>
    </Box>
  )
}
